import React, { useState } from "react";
import styles from "./style.scss";
import HistoryActions from "features/AiResearch/Components/HistoryActions";

interface Props {
  title?: string;
  disabled: boolean;
  onChatTitleEdit: (newTitle: string) => void;
  onChatDelete: () => void;
}

export const Source: React.FC<Props> = ({
  title,
  disabled,
  onChatTitleEdit,
  onChatDelete
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  if (!title) return null;

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <button
          className={styles.titleButton}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          disabled={disabled}
        >
          <span className={styles.titleText}>{title}</span>
          <span className={styles.accordionIcon} />
        </button>
        <div className={styles.historyActions}>
          <HistoryActions
            isShowMenu={isMenuOpen}
            chatTitle={title}
            onCloseMenu={() => setIsMenuOpen(false)}
            onChatTitleEdit={onChatTitleEdit}
            onChatDelete={onChatDelete}
          />
        </div>
      </div>
    </div>
  );
};
